import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";
export var transformProductToOptionLessProduct = function(product) {
    return ILeanProductTile.ILeanProduct.build({
        token: product.token,
        brand_token: product.brand_token,
        name: product.name,
        is_new: product.is_new,
        board_tokens: product.board_tokens,
        expected_ship_date: product.expected_ship_date,
        expected_ship_window_days: product.expected_ship_window_days,
        is_high_sell_through: product.is_high_sell_through,
        maker_best_seller: product.maker_best_seller,
        per_style_min_order_quantity: product.per_style_min_order_quantity,
        state: product.state
    });
};
export var transformBrandToLeanBrand = function(brand) {
    return ILeanProductTile.IBrand.build({
        token: brand.token,
        name: brand.name,
        minimum_order_amount: brand.minimum_order_amount,
        free_shipping_reason: brand.free_shipping_reason,
        forbids_online_only_retailers: brand.forbids_online_only_retailers,
        ships_from_country: brand.ships_from_country,
        is_highlighted_brand_for_promotional_event: brand.is_highlighted_brand_for_promotional_event,
        based_in: brand.based_in
    });
};
